<script setup lang="ts">
import { isTouchScreen } from "@/scripts/helpers";

const { modelValue = "", placeholder = "Schrijf hier je vraag of bericht..." } =
  defineProps<{
    modelValue?: string | number;
    placeholder?: string;
  }>();

const { addOpenPanelHook } = usePanel();

const emit = defineEmits(["update:modelValue", "send"]);

const chatStore = useChatStore();

const input = useTemplateRef("input");

const isInputFocussed = ref(false);

const updateValue = (event: Event) => {
  emit("update:modelValue", event);
};

const submit = () => {
  // Send if input is not empty and the user is not awaiting a reply
  if (!isButtonDisabled.value) {
    emit("send");
  }
};

const isInputDisabled = computed(() => chatStore.awaitingReply);

const isButtonDisabled = computed(() => chatStore.awaitingReply || !modelValue);

const classObject = computed(() => ({
  "is-disabled": isInputDisabled.value,
}));

if (!isTouchScreen()) {
  addOpenPanelHook(() => {
    if (input.value) {
      input.value.focus();
    }
  });
}
</script>

<template>
  <form class="chat-input" :class="classObject" @submit.prevent="submit">
    <FormInput
      ref="input"
      class="input"
      theme="chat"
      :model-value="modelValue"
      :placeholder="placeholder"
      :disabled="isInputDisabled"
      :autofocus="!isTouchScreen()"
      @update:model-value="updateValue"
      @focus="isInputFocussed = true"
      @blur="isInputFocussed = false"
    />
    <ChatSendButton
      class="button"
      :disabled="isButtonDisabled"
      :focussed="isInputFocussed"
      @click="submit"
    />
  </form>
</template>

<style lang="scss" scoped>
.chat-input {
  display: flex;
  transition: opacity 250ms ease;

  &.is-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.input {
  flex-grow: 1;
}

.button {
  flex-shrink: 0;
}
</style>

<style lang="scss">
// START TEMPORARY IOS FIX
.chat-input {
  margin: 0 -1px;

  .input {
    position: relative;
    left: 1px;
    z-index: 1;
    opacity: 1 !important; // Not part of the fix
  }

  .button {
    position: relative;
    left: -1px;
    border-left-width: 2px !important;
  }
}
// END TEMPORARY IOS FIX
</style>
